import React, { useEffect, useState } from 'react'
import ZCard from '../../../../Card/Index'
import { Button, Checkbox, Flex, Form, Input, Modal, Table, Typography } from 'antd';
import { DeleteFilledIcon, EditFilledIcon, FilterFilledIcon, ForwardIcon, PlusFilledIcon } from '../../../../../assets/icons/16';
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionList } from '../../../../../api/reportDetails';
import { setTransactionData, setTransactionLoading, setTxnPagination } from '../../../../../store/reducers/slices/transaction.slice';
import { CURRENCY } from '../../../../../utils/ConstantData';
import { CurrencyFormatWithDecimal } from '../../../../../helper/CurrencyFormate';
import dayjs from 'dayjs';
import CustomAmountText from '../../../../common/CustomAmountText';

const columns = [
    {
        title: 'Transaction Date',
        dataIndex: 'transaction_date',
        key: 'transactionDate',
        fixed: "left",
        width: 150,
        render: (value) => (
            dayjs(value).format('DD/MM/YYYY')
        )

    },
    {
        title: 'Particulars',
        dataIndex: 'particular',
        key: 'Particulars',
    },
    {
        title: 'Cheque/Ref nbr',
        dataIndex: 'cheque_Number',
        key: 'ChequeNumber',
        width: 200,
    },
    {
        title: 'Counterparty',
        dataIndex: 'counterparty',
        key: 'Counterparty',
    },
    {
        title: `Debit(${CURRENCY})`,
        dataIndex: 'transaction_type',
        key: 'debit',
        align: 'right',
        className: 'no-wrap-column',
        render: (value, record) => {
            return (
                (record.transaction_type && record.transaction_type === "DB") ? <CustomAmountText shouldDisplayCurrency={true} value={record.amount} /> : ""
            )
        }
    },
    {
        title: `Credit(${CURRENCY})`,
        dataIndex: 'transaction_type',
        key: 'credit',
        align: 'right',
        className: 'no-wrap-column',
        render: (value, record) => {
            return (
                (record.transaction_type && record.transaction_type === "CR") ? <CustomAmountText shouldDisplayCurrency={true} value={record.amount} /> : ""
            )
        }
    },
    {
        title: `Balance(${CURRENCY})`,
        dataIndex: 'balance',
        key: 'balance',
        align: 'right',
        className: 'no-wrap-column',
        render: (value) => (
            <CustomAmountText shouldDisplayCurrency={true} value={value} />
        )
    },
    {
        title: `Computed Balance(${CURRENCY})`,
        dataIndex: 'computed_balance',
        key: 'computedBalance',
        align: 'right',
        className: 'no-wrap-column',
        width: 200,
        render: (value) => (
            <CustomAmountText shouldDisplayCurrency={true} value={value} />
        )
    },
    {
        title: 'Category',
        dataIndex: 'categories',
        key: 'category',
        className: 'no-wrap-column',
    },
    {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags',
        className: 'no-wrap-column',
    },
    {
        title: 'UPI App',
        dataIndex: 'upiApp',
        key: 'upiapp',
    },
];

const TransactionReport = () => {
    const [openModal, setOpenModal] = useState(false);
    const { selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

    const { isLoading, transactionList, pagination } = useSelector((state) => state.transaction);
    const dispatch = useDispatch();

    // rowSelection objects indicates the need for row selection
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        onSelect: (record, selected, selectedRows) => {
            console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log(selected, selectedRows, changeRows);
        },
    };

    useEffect(() => {
        if (selectedAccountId) {
            const { pageNumber, pageSize, order, sortBy } = pagination;
            dispatch(setTransactionLoading(true))
            fetchData(pageNumber, pageSize, order, sortBy, selectedAccountId);
            window.scrollTo(0, 0); // Scroll to the top of the page


        }
        window.scrollTo(0, 0); // Scroll to the top of the page

    }, [selectedAccountId])

    const fetchData = (pageNumber, pageSize, order, sortBy, accountId) => {
        getTransactionList(accountId, pageNumber, pageSize, order, sortBy).then((resp) => {
            dispatch(setTransactionData(resp.transactions));
            dispatch(setTxnPagination(resp.pagination))
            dispatch(setTransactionLoading(false))
            window.scrollTo(0, 0); // Scroll to the top of the page

            // console.log("txn resp", resp)
        }).catch((error) => {
            dispatch(setTransactionLoading(false))
            console.log("txn error", error)
        })
    }

    return (
        <>
            <ZCard>
                {/* <Flex justify='space-between' align="center" style={{ marginBottom: 8 }}>
                    <Flex align='center' gap={8}>
                        <Typography.Text>sample.pdf </Typography.Text>
                        <ForwardIcon />
                    </Flex>
                    <Flex gap={8}>
                        <Button icon={<FilterFilledIcon />}>Filter</Button>
                        <Button icon={<EditFilledIcon />}>Edit</Button>
                        <Button icon={<DeleteFilledIcon />}>Delete</Button>
                        <Button icon={<PlusFilledIcon />} onClick={() => setOpenModal(true)}>Add</Button>
                    </Flex>
                </Flex> */}
                <Table
                    columns={columns}
                    // rowSelection={{
                    //     ...rowSelection,
                    // }}
                    loading={isLoading}
                    dataSource={[...transactionList]}
                    scroll={{ x: true }}
                    pagination={{
                        total: pagination.totalElements,
                        current: pagination.pageNumber,
                        pageSize: pagination.pageSize
                    }}
                    onChange={(value) => {
                        dispatch(setTransactionLoading(true))
                        fetchData(value.current, value.pageSize, pagination.order, pagination.sortBy, selectedAccountId)
                    }}
                />
            </ZCard>
            {
                openModal &&
                <Modal
                    title="Add Transaction"
                    centered
                    open={openModal}
                    onCancel={() => setOpenModal(false)}
                    footer={<></>}
                    styles={{
                        header: { paddingInline: 16 },
                        body: { paddingInline: 16 },
                        footer: { margin: 0 }
                    }}
                >
                    <Form
                        name="basic"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        style={{
                            maxWidth: 600,
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        // onFinish={onFinish}
                        // onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        layout='vertical'
                    >
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            }
        </>
    )
}

export default TransactionReport